import { createResource, deleteResource, getResource, postgRESTApiUrl, updateResource } from "./api";

const interactApiPrefix = "/interact/api";

// Reads come from PostgREST (owner-scoped by row-level security); writes go through the Rails
// endpoints, which also create and destroy the underlying favorite as memberships come and go.
const listGroups = async ({ signal } = {}) =>
  getResource(`${postgRESTApiUrl()}/rest/v1/favorite_groups?order=name.asc`, { signal });

const fetchMembershipIndex = async ({ signal } = {}) =>
  getResource(`${postgRESTApiUrl()}/rest/v1/favorites_index?limit=10000`, { signal });

const createGroup = (attributes) => createResource(`${interactApiPrefix}/favorite_groups`, { data: { attributes } });

const updateGroup = (id, attributes) =>
  updateResource(`${interactApiPrefix}/favorite_groups/${id}`, { data: { attributes } });

const destroyGroup = (id) => deleteResource(`${interactApiPrefix}/favorite_groups/${id}`);

const addMembership = (groupId, attributes) =>
  createResource(`${interactApiPrefix}/favorite_groups/${groupId}/memberships`, { data: { attributes } });

const removeMembership = (groupId, membershipId) =>
  deleteResource(`${interactApiPrefix}/favorite_groups/${groupId}/memberships/${membershipId}`);

export default {
  listGroups,
  fetchMembershipIndex,
  createGroup,
  updateGroup,
  destroyGroup,
  addMembership,
  removeMembership,
};
